import { useId } from 'react';
import { Root, Loader } from './loading.styles';

export const Loading = ({ minHeight }: { minHeight?: string }) => {
    const gradientId = useId();
    const shapeId = useId();

    return (
        <Root $minHeight={minHeight}>
            <Loader>
                <svg
                    width="64"
                    viewBox="0 0 64 45"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                    focusable="false"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                >
                    <defs>
                        <radialGradient id={gradientId} gradientUnits="userSpaceOnUse" r="560">
                            <stop offset="0" stopColor="#F2F2F4" stopOpacity="0.60" />
                            <stop offset="0.35" stopColor="#F2F2F4" stopOpacity="0.14" />
                            <stop offset="0.85" stopColor="#F2F2F4" stopOpacity="0.02" />
                            <stop offset="1" stopColor="#F2F2F4" stopOpacity="0" />
                            <animateTransform
                                attributeName="gradientTransform"
                                type="translate"
                                values="260 200; -220 -180; 260 200"
                                keyTimes="0; 1; 1"
                                dur="2.6s"
                                repeatCount="indefinite"
                                calcMode="spline"
                                keySplines="0.4 0 0.2 1; 0.4 0 0.2 1"
                            />
                        </radialGradient>
                    </defs>
                    <path
                        id={shapeId}
                        d="M35.3964 1.12258C39.306 -0.0415706 43.461 -0.109199 47.4064 0.927468C51.3517 1.96414 54.936 4.06513 57.7674 7.00052C60.5987 9.93585 62.5687 13.5926 63.4611 17.5712C64.3535 21.5499 64.1343 25.6977 62.8277 29.5603C61.521 33.4228 59.177 36.8521 56.0522 39.473C52.9272 42.094 49.1013 44.1873 45.0686 44.8028H13.9211C11.8343 44.8078 9.77282 44.217 7.89066 43.3163C6.00863 42.4157 4.35371 41.1026 3.04909 39.4749C1.74457 37.8472 0.823421 35.9468 0.354695 33.9145C-0.114024 31.8821 -0.118129 29.7697 0.34199 27.7353C0.802108 25.7009 1.71503 23.7965 3.01279 22.1632C4.31059 20.5299 5.95968 19.2094 7.83802 18.3008C9.71632 17.3923 11.7754 16.9189 13.8621 16.9151C15.9488 16.9112 18.0099 17.3774 19.8916 18.2791C20.6543 14.2735 22.504 10.5544 25.2386 7.52869C27.9731 4.50306 31.4869 2.28677 35.3964 1.12258ZM33.4162 25.5437H42.3189V35.8203L51.2215 19.379H42.3189V9.10232L33.4162 25.5437Z"
                    />
                    <use xlinkHref={`#${shapeId}`} fill="#AEAEB7" />
                    <use xlinkHref={`#${shapeId}`} fill={`url(#${gradientId})`} />
                </svg>
            </Loader>
        </Root>
    );
};
